import * as React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LoadingScreen } from "@/components/LoadingScreen";

/**
 * The application's authenticated boundary. Every existing Falcon route
 * (`/dashboard`, `/portfolio`, ...) renders only inside this guard - an
 * unauthenticated visitor is redirected to `/login`, preserving the page
 * they were trying to reach so login can return them there.
 */
export function ProtectedRoute(): React.JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "bootstrapping") {
    return <LoadingScreen label="Checking your session..." />;
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
